
export const isMobileDisplaySize=(width) => {
  if (width > 480){
    return true
  }else{
    return false
  }
}